import { useEffect } from 'react'
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom'
import { useAccount, useDisconnect } from 'wagmi'
// Import from prototype studio (single source of truth)
import Pagelayout from '../../projects/test-project/src/demo/prototypes/Pagelayout'
import Errorpage from '../../projects/test-project/src/demo/pages/Errorpage'
import Tokenswap from '../../projects/test-project/src/demo/pages/Tokenswap'
import Stakingpage from '../../projects/test-project/src/demo/pages/Stakingpage'
import Bridgepage from '../../projects/test-project/src/demo/pages/Bridgepage'

function ExternalRedirect({ url }: { url: string }) {
  useEffect(() => {
    window.location.replace(url)
  }, [url])
  return null
}

function App() {
  const navigate = useNavigate()
  const location = useLocation()
  const { address, isConnected } = useAccount()
  const { disconnect } = useDisconnect()

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  // Determine current page from location
  const getCurrentPage = () => {
    const path = location.pathname
    if (path === '/staking') return 'stakingpage'
    if (path === '/swap') return 'tokenswap'
    if (path === '/bridge') return 'bridgepage'
    return 'stakingpage'
  }

  // Handle navigation
  const handleNavigate = (page: string) => {
    switch (page) {
      case 'stakingpage':
        navigate('/staking')
        break
      case 'tokenswap':
        navigate('/swap')
        break
      case 'bridgepage':
        navigate('/bridge')
        break
      default:
        navigate('/')
    }
  }

  return (
    <Routes>
      {/* Redirect root to /staking */}
      <Route path="/" element={<Navigate to="/staking" replace />} />

      {/* Application pages */}
      <Route
        path="/staking"
        element={
          <Pagelayout
            currentPage={getCurrentPage()}
            onNavigate={handleNavigate}
            onDisconnectWallet={disconnect}
            isWalletConnected={isConnected}
            walletAddress={address}
          >
            <Stakingpage />
          </Pagelayout>
        }
      />
      <Route
        path="/swap"
        element={
          <Pagelayout
            currentPage={getCurrentPage()}
            onNavigate={handleNavigate}
            onDisconnectWallet={disconnect}
            isWalletConnected={isConnected}
            walletAddress={address}
          >
            <Tokenswap />
          </Pagelayout>
        }
      />
      <Route
        path="/bridge"
        element={
          <Pagelayout
            currentPage={getCurrentPage()}
            onNavigate={handleNavigate}
            onDisconnectWallet={disconnect}
            isWalletConnected={isConnected}
            walletAddress={address}
          >
            <Bridgepage />
          </Pagelayout>
        }
      />

      {/* External redirect: /whitepaper -> wp.farlabs.ai */}
      <Route path="/whitepaper" element={<ExternalRedirect url="https://wp.farlabs.ai" />} />

      {/* 404 Error page */}
      <Route
        path="*"
        element={
          <Errorpage
            errorCode={404}
            errorTitle="Page Not Found"
            errorMessage="The page you are looking for does not exist or has been moved."
            onGoHome={() => navigate('/')}
            onGoBack={() => navigate(-1)}
          />
        }
      />
    </Routes>
  )
}

export default App
